export const PROJECTS_PAGE_TYPE_WRITER_DELAY = 40;
